import SkyNetObjectProfile from '../components/SkyNetObjectProfile'
import {
    DataGridSupportedFeatures,
} from '../components/SkyNetMasterDataGrid/SkyNetMasterDataGrid.types'
import domainConfig from './ServiceCentersDemo.config'

const featuresLists = [DataGridSupportedFeatures.ShowArchived]

const ServiceCentersDemoPage = () => {
    return (
        <SkyNetObjectProfile
            config={domainConfig}
            featuresLists={featuresLists}
        />
    )
}

export default ServiceCentersDemoPage
